import { preferredLocale, type Locale } from './core';

const key = 'designforge:locale:v1';
export const localeRepository = {
  readPreference(): Locale | undefined { try { const value = window.localStorage.getItem(key); return value === 'vi' || value === 'en' ? value : undefined; } catch { return undefined; } },
  read(): Locale { return this.readPreference() ?? 'vi'; },
  suggested(): Locale { return this.readPreference() ?? preferredLocale(navigator.languages?.length ? navigator.languages : [navigator.language]); },
  write(locale: Locale) { try { window.localStorage.setItem(key, locale); } catch { /* Session preference remains available. */ } },
};
